import axios from "axios";

//  Constants
import { API_VERSION } from "../data/constants";

const HOST =
	process.env.NODE_ENV === 'development'
		? process.env.REACT_APP_DEV_SERVER_URL
		: process.env.REACT_APP_PROD_SERVER_URL;

const fetchTestimonials = async () => {
    const response = await axios.get(`${HOST}/api/${API_VERSION}/testimonials`);
    return response;
};

const projectsAPI = {
    fetchTestimonials,

};

export default projectsAPI;
